/**
 * Runtime config, baked at build time from `VITE_*` env (see `.env.<stage>`, generated by
 * `scripts/pull-web-config.ts` from the deployed CloudFormation outputs). None of these are
 * secrets — pool id, client id, API URL and hosted-UI domain are all public.
 */
export interface AppConfig {
  readonly apiUrl: string;
  readonly userPoolId: string;
  readonly userPoolClientId: string;
  readonly hostedUiDomain: string;
  readonly awsRegion: string;
}

const required = (key: string, value: string | undefined): string => {
  if (!value) throw new Error(`Missing ${key} — set it in packages/frontend/web/.env.<stage>`);
  return value;
};

export const config: AppConfig = {
  apiUrl: required('VITE_API_URL', import.meta.env.VITE_API_URL),
  userPoolId: required('VITE_USER_POOL_ID', import.meta.env.VITE_USER_POOL_ID),
  userPoolClientId: required('VITE_USER_POOL_CLIENT_ID', import.meta.env.VITE_USER_POOL_CLIENT_ID),
  hostedUiDomain: required('VITE_HOSTED_UI_DOMAIN', import.meta.env.VITE_HOSTED_UI_DOMAIN),
  awsRegion: required('VITE_AWS_REGION', import.meta.env.VITE_AWS_REGION),
};
